import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const DivisionMobileItem = styled.li`
  display: inline-block;
  color: ${themeGet("colors.panelDark")};
  padding: 14px 18px;
  font-size: 12px;
  white-space: nowrap;
  font-weight: ${props => (props.active ? "600" : "400")};
  color: ${props => (props.active ? themeGet("colors.white.100") : "#B9C4C9")};
  &:hover {
    color: ${themeGet("colors.panelDark")};
  }
`;

DivisionMobileItem.displayName = "DivisionMobileItem";

export { DivisionMobileItem };
